<div class="pacientes-page">
  <!-- Barra superior buscar paciente / Nuevo paciente -->
  <div class="top">
    <!-- BUSCAR PACIENTES -->
    <mat-form-field appearance="outline" class="search-box">
      <mat-label>Buscar paciente</mat-label>

      <input
        #buscador
        matInput
        type="text"
        placeholder="Nombre del paciente"
        [(ngModel)]="busqueda"
        (input)="filtrarPacientes()"
        (keydown.escape)="limpiarBusqueda(buscador)"
      />

      @if (busqueda) {
        <button
          mat-icon-button
          matSuffix
          type="button"
          aria-label="Limpiar búsqueda"
          (click)="limpiarBusqueda(buscador)"
        >
          <mat-icon>close</mat-icon>
        </button>
      } @else {
        <mat-icon matSuffix>search</mat-icon>
      }
    </mat-form-field>

    <!-- NUEVO PACIENTE -->
    <button mat-flat-button class="add-boton" (click)="abrirNuevoPaciente()">
      Nuevo paciente
      <mat-icon>person_add</mat-icon>
    </button>
  </div>

  <!-- Tabla -->
  <div class="tabla-container">
    <table mat-table [dataSource]="pacientes" class="tabla-pacientes">
      <!-- Paciente -->
      <ng-container matColumnDef="paciente">
        <th mat-header-cell *matHeaderCellDef class="col-paciente">Pacientes</th>

        <td mat-cell *matCellDef="let paciente" class="col-paciente">
          {{ paciente.nombre }}
          {{ paciente.apellido }}
          {{ paciente.segundoApellido }}
        </td>
      </ng-container>

      <!-- Información -->
      <ng-container matColumnDef="informacion">
        <th mat-header-cell *matHeaderCellDef>Información</th>

        <td mat-cell *matCellDef="let paciente">
          <button
            mat-icon-button
            (click)="abrirInformacionPaciente(paciente)"
            matTooltip="Ver información del paciente"
          >
            <mat-icon>account_circle</mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- Editar -->
      <ng-container matColumnDef="editar">
        <th mat-header-cell *matHeaderCellDef>Editar</th>

        <td mat-cell *matCellDef="let paciente">
          <button
            mat-icon-button
            (click)="abrirEditarPaciente(paciente)"
            matTooltip="Editar información del paciente"
          >
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- Signos vitales -->
      <ng-container matColumnDef="signos">
        <th mat-header-cell *matHeaderCellDef>Signos vitales</th>

        <td mat-cell *matCellDef="let paciente">
          <button
            mat-icon-button
            (click)="abrirGragicaSignosVitales(paciente)"
            matTooltip="Ver historial de signos vitales"
          >
            <mat-icon>monitor_heart</mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- Recetas -->
      <ng-container matColumnDef="recetas">
        <th mat-header-cell *matHeaderCellDef>Recetas</th>

        <td mat-cell *matCellDef="let paciente">
          <button
            mat-icon-button
            matTooltip="Ver historial de recetas"
            (click)="abrirResumenReceta(paciente)"
          >
            <mat-icon class="material-symbols-outlined"> event_note </mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- Eliminar -->
      @if (tieneRol('MEDIC@') || tieneRol('ADMIN')) {
        <ng-container matColumnDef="eliminar">
          <th mat-header-cell *matHeaderCellDef>Eliminar</th>

          <td mat-cell *matCellDef="let paciente">
            <button
              mat-icon-button
              (click)="eliminarPaciente(paciente)"
              matTooltip="Eliminar paciente"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>
      }

      <tr mat-header-row *matHeaderRowDef="columnas; sticky: true"></tr>

      <tr mat-row *matRowDef="let row; columns: columnas"></tr>
    </table>
  </div>
</div>
